import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
import { useNavigate } from '@/lib/hooks';
import { getPricingText } from '@/lib/util';

const VoucherText = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);

  const searchParams = new URLSearchParams(location.search);
  const removeVoucher = () => {
    dispatch({
      type: ActionTypes.removeVoucher
    });

    // reset price
    dispatch({
      type: ActionTypes.setPricingText,
      payload: getPricingText(state.bundle, false)
    });

    dispatch({
      type: ActionTypes.setFreePurchase,
      payload: false
    });

    // Remove voucher code from URL
    searchParams.delete('voucher');

    // Prevent reload on URL parameter change
    navigate(window.location.pathname, { replace: true });
  };

  return state.voucher?.code ? (
    <p className="vouchertext">
      Gutscheincode <strong>{state.voucher.code} </strong>
      <button
        className="link"
        onClick={() => removeVoucher()}
        type="button"
      >
        entfernen
      </button>
    </p>
  ) : null;
};

export { VoucherText };
